"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gatsby_link_1 = require("gatsby-link");
const React = require("react");
const rebass_1 = require("rebass");
const div_1 = require("./div");
const layout_1 = require("./layout");
class Header extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isMobileMenuOpen: false,
        };
        this.handleMobileMenuClose = () => {
            this.setState({ ...this.state, isMobileMenuOpen: false });
        };
        this.handleMobileMenuOpen = () => {
            this.setState({ ...this.state, isMobileMenuOpen: true });
        };
        this.navigateAndCloseMenu = to => () => {
            this.handleMobileMenuClose();
            gatsby_link_1.navigateTo(to);
        };
    }
    render() {
        const { canViewGuide } = this.props;
        const links = [
            [canViewGuide ? '/guide/' : '/quiz/', 'Guide'],
            ['/about/', 'About'],
        ];
        return (React.createElement(rebass_1.Box, { bg: 'purple', className: 'sans-2' },
            React.createElement(rebass_1.Flex, { alignItems: 'center', justifyContent: 'space-between' },
                React.createElement(rebass_1.Box, null,
                    React.createElement(gatsby_link_1.default, { to: '/' },
                        React.createElement(rebass_1.Heading, { className: 'serif', color: 'white', fontSize: 3, lineHeight: 1, p: 3 }, "Shoulder."))),
                React.createElement(div_1.default, { display: ['none', 'block'] },
                    React.createElement(rebass_1.Flex, null, links.map(([to, text]) => (React.createElement(gatsby_link_1.default, { key: to, to: to },
                        React.createElement(rebass_1.Text, { color: 'white', lineHeight: 1, p: 3 }, text)))))),
                React.createElement(div_1.default, { display: ['block', 'none'] },
                    React.createElement("a", { href: 'javascript:void(0)', onClick: this.handleMobileMenuOpen },
                        React.createElement(rebass_1.Text, { color: 'white', p: 3 }, "Menu")))),
            React.createElement(rebass_1.Drawer, { bg: 'darkPurple', color: 'white', open: this.state.isMobileMenuOpen, p: 3, side: 'right', zIndex: 1 },
                React.createElement("a", { href: 'javascript:void(0)', onClick: this.handleMobileMenuClose },
                    React.createElement(rebass_1.Text, { color: 'white', p: 3 }, "Close")),
                links.map(([to, text]) => (React.createElement("a", { href: 'javascript:void(0)', key: to, onClick: this.navigateAndCloseMenu(to) },
                    React.createElement(rebass_1.Text, { color: 'white', p: 3 }, text)))))));
    }
}
exports.default = props => (React.createElement(layout_1.AuthContext.Consumer, null, ({ canViewGuide }) => React.createElement(Header, Object.assign({}, props, { canViewGuide: canViewGuide }))));



// WEBPACK FOOTER //
// ./src/components/header.tsx